import { Breadcrumbs, Link, Typography } from "@mui/material";

export default function BreadcrumbsMenu() {
    return (
        <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="https://www.conta.com.py/" target="_blank">
                Conta
            </Link>
            <Link
                underline="hover"
                color="inherit"

                href="https://www.conta.com.py/post/impuesto-a-la-renta-personal-irp-conceptos-basicos">
                Calculadora de IRP
            </Link>
            <Typography color="text.primary">Renta de Servicios Personales</Typography>
        </Breadcrumbs>
    );
}